(function () {
  if (window.__cdfAnimate) return;
  window.__cdfAnimate = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function staggerIndex(el, selector, cap) {
    if (!el.parentElement) return 0;
    var peers = Array.prototype.filter.call(el.parentElement.children, function (c) {
      return c.matches && c.matches(selector);
    });
    var i = peers.indexOf(el);
    return cap ? i % cap : i;
  }

  function bindReveals() {
    document.querySelectorAll('.cdf-reveal:not(.in)').forEach(function (el) {
      if (!el.style.getPropertyValue('--cdf-i')) {
        el.style.setProperty('--cdf-i', staggerIndex(el, '.cdf-reveal'));
      }
      io.observe(el);
    });
  }

  /* Card native (collezioni, ricerca, recommendations): animazione one-shot
     rimossa a fine corsa per non interferire con l'hover-lift del tema. */
  function bindCards() {
    if (reduced) return;
    document.querySelectorAll('product-card, .collection-card').forEach(function (card) {
      if (card.__cdfAnim) return;
      if (card.closest('.header, header-component, .header-drawer, .predictive-search-results, quick-add-modal, .cart-drawer')) return;
      card.__cdfAnim = true;
      card.classList.add('cdf-anim-in');
      card.style.setProperty('--cdf-i', staggerIndex(card, '*', 6));
      card.addEventListener('animationend', function handle(e) {
        if (e.animationName !== 'cdf-fade-up') return;
        card.classList.remove('cdf-anim-in', 'in');
        card.style.removeProperty('--cdf-i');
        card.removeEventListener('animationend', handle);
      });
      io.observe(card);
    });
  }

  function boot() {
    bindReveals();
    bindCards();
  }

  boot();
  document.addEventListener('shopify:section:load', boot);

  /* Le collezioni Horizon caricano altre card con filtri/paginazione AJAX. */
  var mo = new MutationObserver(function () {
    clearTimeout(mo.__t);
    mo.__t = setTimeout(boot, 120);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
